import BaseRepository from '@/api/BaseRepository';

export default class AuthRepository extends BaseRepository {

    public login(username: string, password: string): Promise<any> {
        return this.axiosClient.post('/auth/login', { username, password });
    }

    public refreshToken(token: string): Promise<any> {
        return this.axiosClient.post('/auth/refreshToken', { token });
    }
}
